var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error"},[_c('img',{staticClass:"icon-error",attrs:{"src":(_vm.CDN + "/error_tip.png"),"alt":"icon error"}})])}
var staticRenderFns = []

export { render, staticRenderFns }